import { Single as Confirmation } from './Single';

export default Confirmation;
